import React, { useEffect, useState } from 'react'
import CompanyContainer from '../containers/CompaniesContainer/CompaniesContainer'
import Seo from '../common/Components/Seo/Seo'
import SearchSchema from '../common/Components/StructuredData/SearchSchema'
import axios from 'axios';
import apiUrl from "../common/config/apiUrl";
import apiKey from "../common/config/apiKey";

const Search = () => {
  const [airports, setAirports] = useState([]);

  useEffect(() => {
    (async () => {
      try {
        const response = await axios.get(`${apiUrl}/airports?key=${apiKey}`);
        if (response?.data?.response_code == 200) {
          setAirports(response?.data?.data);
        }
      } catch (error) {
        console.log("error", error);
      }
    })();
  }, []);
  return (
    <>
      <Seo
        seo={{
          title: "Search Airport Parking Deals | Compare & Save | Airport Parking Deals",
          description: "Search and compare airport parking deals across all major airports. Find the best prices for Park & Ride, Meet & Greet, and Onsite parking. Book now and save up to 60%.",
          keywords: "search airport parking, compare parking deals, airport parking search, find cheap parking, parking comparison, airport parking prices"
        }}
      />
      <SearchSchema />
      {/* Primary color background under the absolute header */}
      <div className="w-full bg-[#0C735F] h-28 md:h-[180px]"></div>
      <CompanyContainer airports={airports} setAirports={setAirports} />
    </>
  )
}

export default Search